import FirebaseGateway from "core/firebaseGateway";
import SmaContacto from "interfaces/SmaContacto";
import Navigation from "components/navigation";
import { applyTemplateToElement } from "core/utils";
const _ko = require("ko");

document.addEventListener("DOMContentLoaded", () => {
  const nav = new Navigation();
  $("[data-ko=navigation]").each((idx, element) => {
    nav.setActive("form");
    applyTemplateToElement(nav.tmplName, element);
    _ko.applyBindings(nav, element);
  });
  let loading = 0;
  let loadedWithError = false;
  //@ts-ignore
  const form: HTMLFormElement = document.getElementById("form-contacto");

  form.addEventListener("submit", (event: Event) => {
    event.preventDefault();
    // @ts-ignore
    const captcha = grecaptcha;

    const captchaToken = captcha.getResponse();
    if (!captchaToken) {
      alert("Falta terminar el captcha");
      // console.log("captcha not yet completed.");
      // captcha.execute();
    } else {
      verifyToken(captchaToken);
    }
  });

  function verifyToken(token: string) {
    const formControls: NodeListOf<Element> =
      document.querySelectorAll(".form-control");
    const submitBtn: HTMLElement = document.getElementById("submit-btn");
    const loader: HTMLElement = document.getElementById("loader");
    const progress: HTMLElement = loader.querySelector(".progress-bar");

    submitBtn.classList.add("d-none");
    loader.classList.remove("d-none");
    startLoading(progress);
    formControls.forEach((element) => {
      element.setAttribute("readonly", "readonly");
    });

    // const url =
    //   "http://localhost:5001/volvamos-a-imprimir/us-central1/captcha?token=" +
    //   token;
    const url =
      "https://captchav2-m45xt74eea-uc.a.run.app?token=" +
      token;

    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          saveContact();
        } else {
          alert("No se puede guardar contacto, por favor intente más tarde");
        }
      })
      .catch(() =>
        alert("No se puede guardar contacto, por favor intente más tarde")
      );
  }

  function saveContact() {
    const successMsg: HTMLElement = document.getElementById("thanks");
    const formData = new FormData(form);

    setTimeout(() => {
      saveContacto(formData, form, successMsg);
    }, 500);
  }

  function startLoading(ld: HTMLElement) {
    if (loading < 95) {
      setTimeout(() => {
        loading += 1.5;
        ld.style.width = `${loading}%`;
        ld.setAttribute("aria-value-now", loading + "");
        startLoading(ld);
      }, 100);
    } else {
      if (loadedWithError) {
        ld.classList.remove("bg-success");
        ld.classList.add("bg-danger");
      }
      ld.style.width = `${loading}%`;
      ld.setAttribute("aria-value-now", loading + "");
    }
  }

  function saveContacto(
    formData: FormData,
    form: HTMLFormElement,
    successMsg: HTMLElement
  ) {
    const fb = new FirebaseGateway();
    const contact: SmaContacto = {
      nombre: formData.get("nombre").toString(),
      paterno: formData.get("apellido-paterno").toString(),
      materno: formData.get("apellido-materno").toString(),
      telefono: formData.get("telefono").toString(),
      email: formData.get("email").toString(),
      ciudad: formData.get("ciudad").toString(),
      laboratorio: formData.get("laboratorio-fotografico").toString(),
      comentarios: formData.get("comentarios").toString(),
      enviado: false,
    };

    fb.saveContacto(contact).then((saved) => {
      if (saved) {
        loading = 100;
        setTimeout(() => {
          form.classList.add("d-none");
          successMsg.classList.remove("d-none");
        }, 1000);
      } else {
        // ERROR WHAT TO DO ?
        loading = 100;
        loadedWithError = true;
      }
    });
  }
});
